/* The mockup's `.card.plist`: a card of full-width buttons, the open one filled. */
.list {
  display: flex;
  flex-direction: column;
  padding: var(--space-1);
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.rows {
  margin: 0;
  padding: 0;
  list-style: none;
}

.profile,
.new {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  inline-size: 100%;
  padding: var(--space-2) 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text);
  font: inherit;
  text-align: start;
  cursor: pointer;
}

.profile:hover,
.new:hover {
  background: var(--state-hover);
}

.profile[aria-current="true"] {
  background: var(--state-active);
}

.profile:focus-visible,
.new:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}

.name {
  min-inline-size: 0;
  overflow: hidden;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Two lines as in the mockup: the colour dot and the name, then where it is active. */
.top,
.bottom {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  inline-size: 100%;
}

.bottom {
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-2);
}

/* The system default goes last and quieter: a starting point, not one of the person's profiles. */
.profile[data-muted="true"] .name {
  color: var(--text-muted);
  font-weight: var(--font-weight-regular);
}

.meta {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.separator {
  block-size: 1px;
  margin: var(--space-1);
  background: var(--border);
}

.new {
  flex-direction: row;
  align-items: center;
  gap: var(--space-2);
  color: var(--text-muted);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  margin: var(--space-2) 10px;
}

.emptyTitle {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.emptyBody {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

/*
 * On the current row the hint steps up to the muted text: `--text-subtle` over `--state-active`
 * is 4.48:1 in the dark theme, under AA (UX-13 axe, decision D-UX-48).
 */
.profile[aria-current="true"] .meta {
  color: var(--text-muted);
}

/* Mockup v3 P5: four dots of the palette after the name (the mockup's `.dots`). */
.dots {
  display: inline-flex;
  flex: none;
  gap: 3px;
  margin-inline-start: auto;
}
